import { Grid } from '@chakra-ui/react';
import { PropsWithChildren, useState } from 'react';
import { useInView } from 'react-intersection-observer';

export function KollectionsControlsWrapper({
  children,
  stickyBackgroundColor,
  rootMargin,
}: PropsWithChildren & { stickyBackgroundColor?: string; rootMargin?: string }) {
  const [filtersSticky, setFiltersSticky] = useState(false);

  const { ref } = useInView({
    threshold: 1,
    rootMargin: rootMargin || '-81px 0px 0px 0px',
    onChange: (_, entry) => {
      setFiltersSticky(entry.intersectionRatio < 1);
    },
  });

  return (
    <Grid
      gap={4}
      position="sticky"
      top="var(--scroll-padding-top)"
      zIndex={2}
      py={2}
      mt={-2}
      pb={4}
      mb={-4}
      ref={ref}
      _before={{
        display: 'block',
        content: '""',
        position: 'absolute',
        top: 0,
        left: '50%',
        w: '100vw',
        h: '100%',
        transform: 'translateX(-50%)',
        background: filtersSticky ? stickyBackgroundColor || 'background' : 'transparent',
        zIndex: -1,
      }}
    >
      {children}
    </Grid>
  );
}
